import { useEffect, useState } from 'react';
import { Button, makeStyles, TextField } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { logInUserMobile } from "../../../actions/driverMobileActions";
import FullscreenLoading from '../../../components/FullscreenLoading';
import { normalizeMobile } from '../../../utilities/driverMobileAuth';

const useStyles = makeStyles((theme)=> ({
    loginContainer: {
        width: 285,
        marginTop: 150,
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    loginTitle: {
        color: '#101820',
        fontSize: 20,
        fontWeight: 'bold',
        letterSpacing: 0,
        lineHeight: 1.2,
        whiteSpace: 'nowrap'
    },
    loginDescription: {
        height: 42,
        width: 285,
        color: '#8A8B8A',
        fontSize: 16,
        letterSpacing: 0,
        marginTop: 10
    },
    loginParam: {
        height: 24,
        color: '#101820',
        fontSize: 18,
        letterSpacing: 0
    },
    loginInput: {
        height: 48,
        width: 285
    },
    loginButton: {
        height: 41,
        width: 251,
        borderRadius: 24.5,
        backgroundColor: '#F68D2E',
        color: 'white',
        marginTop: 107,
        '&:hover': {
            background: "#F68D2E",
        },
    },
    errorMessage: {
        color: '#E91F1F',
        fontSize: 16,
        letterSpacing: 0
    }
}))

const ERROR_MSG = 'Invalid login information. Please check details and try again.';

function LoginDriverMobile() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    window.localStorage.setItem('menu', 0);

    const [driverId, setDriverId] = useState('');
    const [mobile, setMobile] = useState('');
    const [loading, setLoading] = useState(false);
    const [loginFail, setLoginFail] = useState(false);

    function handleLogin() {
        setLoginFail(false);
        const driverIdVal = driverId || document.getElementById("driverId")?.value || '';
        const mobileVal = mobile || document.getElementById("mobile")?.value || '';
        const mobileNorm = normalizeMobile(mobileVal);
        if (!mobileNorm || !driverIdVal.trim()) {
            setLoginFail(true);
            return;
        }
        setLoading(true);
        dispatch(logInUserMobile(driverIdVal.trim(), mobileNorm))
            .then(() => {
                setLoading(false);
                window.localStorage.setItem('income-overview-open', true);
                history.push('/driverMobile/main');
            })
            .catch(() => {
                setLoading(false);
                setLoginFail(true);
            });
    }

    useEffect(() => {
        setLoginFail(false);
    }, []);

    return (
        <div className={classes.loginContainer}>
            <div className={classes.loginTitle}>Verify Your Identity</div>
            <div className={classes.loginDescription}>Please sign in to view your performance details.</div>
            <div className={classes.loginParam} style={{marginTop: 33}}>Driver ID</div>
            <TextField
                id='driverId'
                variant="standard"
                className={classes.loginInput}
                type="text"
                inputProps={{ inputMode: 'numeric' }}
                onChange={(e) => setDriverId(e.target.value)}
            />
            <div className={classes.loginParam} style={{marginTop: 29}}>Mobile Number</div>
            <TextField
                id='mobile'
                variant="standard"
                className={classes.loginInput}
                type="tel"
                inputProps={{ inputMode: 'numeric' }}
                onPaste={(e) => e.preventDefault()}
                onChange={(e) => setMobile(e.target.value)}
            />
            <div className={classes.errorMessage} hidden={!loginFail}>{ERROR_MSG}</div>
            <div style={{ textAlign: 'center' }}>
                <Button
                    className={classes.loginButton}
                    onClick={handleLogin}
                    disabled={loading}
                >
                    Sign In
                </Button>
            </div>
            <FullscreenLoading open={loading} />
        </div>
    )
}
export default LoginDriverMobile;